import { render, staticRenderFns } from "./WineDuplicateListDialog.vue?vue&type=template&id=dfbc6c26&scoped=true"
import script from "./WineDuplicateListDialog.vue?vue&type=script&lang=js"
export * from "./WineDuplicateListDialog.vue?vue&type=script&lang=js"
import style0 from "./WineDuplicateListDialog.vue?vue&type=style&index=0&id=dfbc6c26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbc6c26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfbc6c26')) {
      api.createRecord('dfbc6c26', component.options)
    } else {
      api.reload('dfbc6c26', component.options)
    }
    module.hot.accept("./WineDuplicateListDialog.vue?vue&type=template&id=dfbc6c26&scoped=true", function () {
      api.rerender('dfbc6c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineDuplicateListDialog.vue"
export default component.exports